import React, { useEffect, useContext, useState } from 'react';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import Icon_Reject from '../../Assets/Icons/Icon_Color_Reject.png';
import { Context_UI } from '../../Contexts/Context_UI';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import UI_Card from '../ERUMAUI/UI_Card';
import UI_ChipGroup from '../ERUMAUI/UI_ChipGroup';
import { useAccounts } from '../../Contexts/Context_Accounts';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';
import { useTemplating } from '../../Contexts/Context_Templating';
import { useStatus } from '../../Contexts/Context_Status_Global';

export default function Subwindow_Modal_Reservation_Reject({ id, zIndex, isActive }) {
    const UI = useContext(Context_UI);
    const { Schedule_Information, Time_Range_Parse, Schedule_Action_Mode, Status_Parse } = useScheduleManagement();
    const { Room_Get_Address } = useMapRenderer();
    const { Account_Fetch_ByID_Basic } = useAccounts();
    const [Account, Account_Set] = useState({ Name: "", Email: "" });
    const { Template_List } = useTemplating();
    const { Confirmer_Respond } = useStatus();
    const Close = (Type) => {
        setTimeout(function () {
            UI.Subwindows_Close(id);
        }, 500);
    }

    
    useEffect(() => {
        Fetch(Schedule_Information.Requester.RequesterID)
    }, [Schedule_Information]);

    useEffect(() => {
        document.getElementById("Reject_Reason").querySelector(".Dropdown_Button").click();
    }, []);
    
    const Fetch = async (ID) => {
        const Data = await Account_Fetch_ByID_Basic(ID);
        Account_Set(Data);
    }

    const Confirm = async () => {
        const Cleared = await UI.Input_Evaluate([{
            ID: "Reject_Reason",
            Type: "Dropdown",
            AC: "No rejection reason specified",
            Prompt: "Specifying a reason is required."
        }])
        if (Cleared) {
            // console.log(Cleared);
            Confirmer_Respond(true, { Value: document.getElementById("Reject_Reason").querySelector(".Dropdown_Button").querySelector(".Dropdown_Button_Text").innerText }, true, "Window_ScheduleManagement_Reserve_Reject");
        }
        
        // UI.Subwindows_Close('Window_MapEditor_RippleDelete');
    }

    const Cancel = () => {
        Confirmer_Respond(false, {}, true, "Window_ScheduleManagement_Reserve_Reject");
    }

    return (
        <ui-subwindow Type='Subwindow' id={id} State='Active' Visibility='Open' {...(!isActive ? { inert: "" } : {})} style={{ height: "75%" }}>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>

                </h2>
                <button className='Subwindow_TitleBar_Control' onClick={Cancel}             >
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content>
                <div style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: "10px", alignItems: "center" }}>
                    <div className='Subwindow_Content_Icon'>
                        <img src={Icon_Reject} className='Subwindow_Content_Icon_Image' draggable={false} loading='lazy' />
                    </div>
                    <div>
                        <h2 className='Subwindow_TitleBar_Title' style={{ textAlign: "left", marginBottom: "10px" }}>
                            Are you sure you want to reject this reservation request?
                        </h2>

                        <p className='General_Paragraph' style={{ textAlign: "left", marginBottom: "10px" }}>
                            Please specify a reason for the rejection of this request. You can view the reservation information beforehand. Please remember that unless you have Edit permissions, this action cannot be undone.
                        </p>
                    </div>
                </div>
                <div className='General_Split' Split="2">
                    <div>
                        <UI_Card Type="Panel_Info" Text="Name" Figure={Schedule_Information.Name} />
                        <UI_Card Type="Panel_Info" Text="Requested time" Figure={Time_Range_Parse(Schedule_Information.Time.Start, Schedule_Information.Time.End)} />
                        <UI_Card Type="Panel_Info" Text="Requested location" Figure={Room_Get_Address(Schedule_Information.RoomID)} />
                        <UI_Card Type="Panel_Info" Text="Type of activity" Figure={Schedule_Information.Activity.Type} />
                    </div>
                    <div>
                        <UI_Card Type="Panel_Info" Text="Requestant's name" Figure={Account.Name} />
                        <UI_Card Type="Panel_Info" Text="Requestant's email" Figure={Account.Email} />
                        <UI_Card Type="Panel_Info" Text="Number of attendees" Figure={Schedule_Information.Activity.Attendees.Names.length} />
                        <div className='AM_Details_Data' id={id}>
                            <p className='General_Paragraph'>
                                Reservation status
                            </p>
                            <UI_ChipGroup Items={Status_Parse(Schedule_Information)}/>
                        </div>
                        <div className='AM_Details_Data' id={id}>
                            <p className='General_Paragraph'>
                                Pick a rejection reason (rejecting as <b>{Schedule_Action_Mode}</b>)
                            </p>
                            <UI_Dropdown id="Reject_Reason" Items={Template_List.Reason.Request_Denied} InitialTitle="No rejection reason specified"/>
                        </div>
                    </div>
                    
                    
                </div>



            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Cancel}>
                    Cancel
                </button>
                <button className='General_Button Subwindow_Control' Type='Secondary' State="Negative" onClick={Confirm}>
                    Reject as {Schedule_Action_Mode}
                </button>
            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
